import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('info-dialog', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('info-dialog');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
